<template>
  <v-dialog v-model="modelValue" max-width="400px">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>Are you sure you want to {{ actionLabel }} <strong>{{ contract.contractNumber }}</strong>?</v-card-text>
      <v-card-actions>
        <v-btn text @click="$emit('update:modelValue', false)">Cancel</v-btn>
        <v-btn :color="color" @click="$emit('confirmed')">{{ actionLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    contract: Object,
    title: String,
    actionLabel: String,
    color: String
  },
  emits: ['update:modelValue', 'confirmed']
}
</script>